import type { News } from '../types';

/** Sorts news in reverse chronological order and optionally caps the result, e.g. for the front page teaser. */
export const selectNews = (data: Array<News>, limit?: number): Array<News> => {
  if (!data || !data.length) return [];

  const sorted = [...data].sort((a, b) => (a.date < b.date ? 1 : -1));

  return typeof limit === 'number' ? sorted.slice(0, limit) : sorted;
};

export const hasUnreadItems = (news: News) => {
  const forceHide = window.localStorage.getItem('isPlaywright');
  const lastRead = localStorage.getItem('news.lastRead');

  return !forceHide && news && news.date !== lastRead;
};

export const setReadItems = (news: News) => {
  localStorage.setItem('news.lastRead', news && news.date);
};
